module.exports = __webpack_public_path__ + "static/media/yuyo.84ef8422.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/yuyo.png
// module id = 399
// module chunks = 0